import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let token = JSON.parse(localStorage.getItem("token"));

    let headers = {
        Authorization: `Bearer ${token}`,
    };

    // If data is NOT FormData, set Content-Type to application/json
    if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const requestOptions = {
        method: method,
        headers: headers,
        body: data instanceof FormData ? data : JSON.stringify(data)
    };

    return requestOptions;
};

export const notificationListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}notifications?paginate=${payload.paginate}&sort=${payload.sort_by}&sort_order=${payload.sort_order}&size=${payload.size}&search=${payload.search}&filter[unread]=${payload.isUnread || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const notificationDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}notifications/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const addNotificationApi = async (payload) => {

    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}notifications`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const updateNotificationApi = async (payload) => {
    const request = requestAuthOption("POST", payload.data)
    try {
        const response = await fetch(
            `${server}notifications/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field" || data?.code === "validation_failed") {
                        reject(data.errors);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const deleteNotificationApi = async (payload) => {
    let request = {}
    if (payload?.multiple) {
        request = requestAuthOption("DELETE", payload?.id)
    } else {
        request = requestAuthOption("DELETE")

    } try {
        const response = payload?.multiple ? await fetch(`${server}notifications`, request) : await fetch(`${server}notifications/${payload?.id}`, request)
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    resolve({ data: data, api: payload?.api });
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const exportNotificationApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}notifications/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const readNotificationApi = async (payload) => {
    const request = requestAuthOption("PUT", payload)
    try {
        const response = await fetch(
            `${server}notifications/read`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};

export const bulkReadNotificationApi = async (payload) => {
    const request = requestAuthOption("PUT")
    try {
        const response = await fetch(
            `${server}notifications/read-all`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })
    }
};
